import { useParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import axios from "axios";
import Retailer from "../../network/models/Retailer";

function NewUserDetails() {
    const { id } = useParams();
    const [retailer, setRetailer] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRetailer = async () => {
            try {
                const response = await axios.get(
                    `https://us-central1-imagine-bc615.cloudfunctions.net/getRetailer?id=${id}`
                );
                if (response.data.success) {
                    setRetailer(new Retailer(response.data.data));
                } else {
                    throw new Error("Failed to fetch inventory");
                }
            } catch (error) {
                setError(error.message);
            }
        };

        fetchRetailer();
    }, [id]);

    if (error) {
        return <div className="text-red-500 text-center py-4">Error: {error}</div>;
    }

    if (!retailer) {
        return <div className="text-center py-10 text-gray-600">Loading...</div>;
    }

    return (
        <div className="flex justify-center items-center">
            <div className="bg-white shadow-lg rounded-2xl p-6 w-full max-w-3xl">
                <h2 className="text-2xl font-bold text-white mb-6 text-center">User Details</h2>
                <div className="grid grid-cols-2 gap-4 text-gray-700">
                    <div><span className="font-semibold">Full Name:</span> {retailer.name}</div>
                    <div><span className="font-semibold">Email:</span> {retailer.email}</div>
                    <div><span className="font-semibold">Phone:</span> {retailer.mobile}</div>
                    <div><span className="font-semibold">Company Name:</span> {retailer.companyName}</div>
                    <div><span className="font-semibold">GST No.:</span> {retailer.gstNumber}</div>
                    <div><span className="font-semibold">Username:</span> {retailer.userName}</div>
                    <div><span className="font-semibold">Password:</span> {retailer.password}</div>
                    <div><span className="font-semibold">Role:</span> {retailer.role}</div>
                    <div className="col-span-2"><span className="font-semibold">Address:</span> {retailer.address}</div>
                    <div><span className="font-semibold">Pincode:</span> {retailer.pinCode}</div>
                    <div><span className="font-semibold">Country:</span> India</div>
                    <div><span className="font-semibold">State:</span> {retailer.state}</div>
                    <div><span className="font-semibold">City:</span> {retailer.city}</div>
                </div>
            </div>
        </div>
    );
}

export default NewUserDetails;